import React, { useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "~/components/Spinner";
import SidebarContainer from "~/containers/SidebarContainer";
import { findMenuByApplicationName } from "~/store/ducks/applicationMenu/actionTypes";
import ApplicationMenuItem from "./ApplicationMenuItem";

const ApplicationMenu = ({ applicationName, showMenu = true }) => {
  const dispatch = useDispatch();

  const { isLoadingMenu, successDelete, successEdit } = useSelector(
    (state) => state.applicationMenuReducer
  );

  useEffect(() => {
    if (applicationName) {
      dispatch(findMenuByApplicationName(applicationName));
    }
  }, [applicationName]);

  useEffect(() => {
    if ((successEdit || successDelete) && applicationName) {
      dispatch(findMenuByApplicationName(applicationName));
    }
  }, [successDelete, successEdit]);

  return (
    <>
      <SidebarContainer>
        {!isLoadingMenu && <ApplicationMenuItem showMenu={showMenu} />}
        <Spinner spinning={isLoadingMenu} />
      </SidebarContainer>
    </>
  );
};
export default withNamespaces()(ApplicationMenu);
